import { Controller } from '@hotwired/stimulus'

// Shows a live "value + unit" label beside a range input. Generic across any px/size range:
// wrap one range input (data-range-output-target="input") and one <output>
// (data-range-output-target="output") together, with data-range-output-unit-value="px".
export default class extends Controller {
  static targets = ['input', 'output']
  static values = { unit: { type: String, default: '' } }

  connect() {
    this.update()
  }

  update() {
    this.outputTarget.textContent = `${this.inputTarget.value}${this.unitValue}`
  }
}
